import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SignupFlowService } from '@app/modules/signup-new/services/signup-flow.service';

type SignupWizardStep =
  | 'name'
  | 'mobile'
  | 'validate-mobile'
  | 'properties'
  | 'channels'
  | 'password'
  | 'onboarding'
  | 'done';
const stepsB: SignupWizardStep[] = ['name', 'mobile', 'validate-mobile', 'properties', 'channels'];
const stepsC: SignupWizardStep[] = ['properties', 'channels', 'name', 'mobile', 'validate-mobile'];
const lastSteps: SignupWizardStep[] = ['password', 'onboarding', 'done'];

@Injectable({
  providedIn: 'root',
})
export class SignupWizardService {
  private signupWizardsSteps: SignupWizardStep[] = stepsB;

  constructor(
    private router: Router,
    private signupFlowService: SignupFlowService
  ) {
    this.signupFlowService.flow$.subscribe((value) => {
      switch (value) {
        case 'B':
          this.signupWizardsSteps = stepsB.concat(lastSteps);
          break;
        case 'C':
          this.signupWizardsSteps = stepsC.concat(lastSteps);
          break;
      }
    });
  }

  init() {
    this.router.navigate([`/signup/${this.signupWizardsSteps[0]}`]);
  }

  next(source: SignupWizardStep) {
    const sourceIndex = this.signupWizardsSteps.findIndex((step) => step === source);
    if (sourceIndex === -1) {
      this.router.navigate([`/signup`]);
      return;
    }

    const nextStep = this.signupWizardsSteps[sourceIndex + 1];
    if (nextStep) {
      this.router.navigate([`/signup/${nextStep}`]);
    }
  }

  isFirst(source: SignupWizardStep) {
    return this.signupWizardsSteps[0] === source;
  }
}
